/**
 * Chutt... - Trending Keywords Cloud (Style Meltwater)
 * Hashtags/mots-cles affiches en chips/pills de tailles variees, couleur teal, layout scatter.
 * Pur CSS avec MUI Chip - pas de lib externe.
 */
import React, { useMemo } from 'react';
import { Box, Chip } from '@mui/material';
import { colors } from '../../styles/colors';

function TrendingKeywordsCloud({ keywords }) {
  // Melanger pour un effet "cloud" naturel (stable entre renders)
  const shuffled = useMemo(() =>
    keywords && keywords.length > 0
      ? [...keywords].sort(() => Math.random() - 0.5)
      : [],
    [keywords]
  );

  if (!keywords || keywords.length === 0) return null;

  // Calculer les tailles relatives
  const maxCount = Math.max(...keywords.map(k => k.count), 1);
  const minCount = Math.min(...keywords.map(k => k.count), 0);

  const getSize = (count) => {
    const ratio = (count - minCount) / (maxCount - minCount || 1);
    return {
      fontSize: `${0.7 + ratio * 0.5}rem`,
      height: `${26 + ratio * 16}px`,
      px: 1 + ratio * 1.5,
    };
  };

  return (
    <Box sx={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 1,
      justifyContent: 'center',
      alignItems: 'center',
      p: 2,
    }}>
      {shuffled.map((kw, idx) => {
        const size = getSize(kw.count);
        return (
          <Chip
            key={idx}
            label={kw.text}
            sx={{
              height: size.height,
              fontSize: size.fontSize,
              fontWeight: 600,
              bgcolor: `${colors.teal}12`,
              color: colors.teal,
              border: `1px solid ${colors.teal}30`,
              borderRadius: '999px',
              '& .MuiChip-label': {
                px: size.px,
              },
              transition: 'all 0.2s ease',
              '&:hover': {
                bgcolor: `${colors.teal}25`,
                transform: 'scale(1.05)',
              },
            }}
          />
        );
      })}
    </Box>
  );
}

export default TrendingKeywordsCloud;
